export const itemBackground = (state) => {
    switch (state) {
        case 'default':
            return 'transparent';
        default:
            return `primary._states.${state}`;
    }
};
